import { useModal } from '~/composables/useModal';

export function useAllIncludedModal() {
  function openAllIncludedModal(activeProduct: any) {
    const { modalShow } = useModal({
      component: () => import('~/components/v2/AllIncludedModal.vue'),
      componentProps: {
        activeProduct,
        packageName: activeProduct?.title ?? activeProduct?.productName ?? '',
      },
      modalProps: {
        componentName: 'AllIncludedModal',
        adaptive: true,
        width: '95%',
        maxWidth: 1200,
        height: 'auto',
        maxHeight: 900,
      },
    });

    modalShow();
  }

  return {
    openAllIncludedModal,
  };
}
